export default "__VITE_ASSET__CWUaEKt0__"